export const APP_URL = "https://split-it.bjoernpeter.de";

export const getShareMessage = (code, groupName, origin = APP_URL) =>
  `Tritt unserer Gruppe "${groupName}" bei.

Öffne diesen Link auf deinem Smartphone: ${origin}/join/${code}

Oder gib folgenden Code auf ${origin}/ ein: ${code}`;
